import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import DatabaseKeyPage from '../pages/DatabaseKeyPage';
import api from '../api/api';
import { getdatabasekey } from '../api/configHelper';

export default function InitialPage() {
  const [keys, setKeys] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const loadKeys = async () => {
      try {
        const databaseKeys = await getdatabasekey();
        setKeys(databaseKeys);
        if (databaseKeys.length === 1) {
          // Single key, set it and go to login
          const key = databaseKeys[0];
          sessionStorage.setItem("databaseKey", key);
          const companyData = await api.Companydetails();
          sessionStorage.setItem("companyDetails", JSON.stringify(companyData));
          navigate("/login");
        } else {
          setLoading(false);
        }
      } catch (err) {
        console.error("Failed to load database keys:", err);
        setLoading(false);
      }
    };
    loadKeys();
  }, [navigate]);

  if (loading) {
    return (
      <div className="relative h-screen w-screen flex items-center justify-center">
        <div className="text-center">
          <div className="loading loading-spinner loading-lg"></div>
          <p className="mt-4">Loading...</p>
        </div>
      </div>
    );
  }

  if (keys.length > 1) {
    return <DatabaseKeyPage />;
  }

  // If no keys or error, perhaps show error, but assuming there are keys
  return null;
}